const $body = document.querySelector('body')
let scrollPosLock = 0;

const ScrollLock =  {
  enable() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    scrollPosLock = window.pageYOffset;
    $body.style.overflow = 'hidden';
    $body.style.position = 'fixed';
    $body.style.top = `-${scrollPosLock}px`;
    $body.style.width = '100%';
    $body.style.paddingRight = scrollbarWidth + 'px';
    const classes = ['modal-open', 'group/body']
    $body.classList.add(...classes)
  },
  disable() {
    $body.style.removeProperty('overflow');
    $body.style.removeProperty('position');
    $body.style.removeProperty('top');
    $body.style.removeProperty('width');
    $body.style.removeProperty('padding-right');
    const classes = ['modal-open', 'group/body']
    $body.classList.remove(...classes)
    window.scrollTo(0, scrollPosLock);
  }
};
export default ScrollLock;